var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57881 0.0037452L7.23301 0C4.59758 0 2.89445 1.73871 2.89445 4.42982V6.47227H0.535847C0.332036 6.47227 0.166992 6.63668 0.166992 6.83949V9.79876C0.166992 10.0016 0.332224 10.1658 0.535847 10.1658H2.89445V17.633C2.89445 17.8358 3.05949 18 3.2633 18H6.3406C6.54441 18 6.70946 17.8356 6.70946 17.633V10.1658H9.46721C9.67102 10.1658 9.83607 10.0016 9.83607 9.79876L9.83719 6.83949C9.83719 6.74211 9.79824 6.64886 9.72917 6.57994C9.66011 6.51103 9.56601 6.47227 9.46815 6.47227H6.70946V4.74086C6.70946 3.90868 6.90875 3.48622 7.99819 3.48622L9.57843 3.48566C9.78205 3.48566 9.9471 3.32124 9.9471 3.11863V0.370775C9.9471 0.168347 9.78224 0.00411972 9.57881 0.0037452Z",
    fill: "#000B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.75212b61bb0049553a15e91be3268292.svg";
export { ForwardRef as ReactComponent };